export default __webpack_public_path__ + "static/media/tennis_reg.0ae1318f.png";